import { render } from "./AposSlat.vue?vue&type=template&id=18fb50ac&scoped=true"
import script from "./AposSlat.vue?vue&type=script&lang=js"
export * from "./AposSlat.vue?vue&type=script&lang=js"

import "./AposSlat.vue?vue&type=style&index=0&id=18fb50ac&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fb50ac"],['__file',"ui/ui/apos/components/AposSlat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18fb50ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18fb50ac', __exports__)) {
    api.reload('18fb50ac', __exports__)
  }
  
  module.hot.accept("./AposSlat.vue?vue&type=template&id=18fb50ac&scoped=true", () => {
    api.rerender('18fb50ac', render)
  })

}


export default __exports__